import { assertExists } from '@blocksuite/global/utils';
import { getSelectedContentModels } from '../../utils/index.js';
export const getSelectedModelsCommand = (ctx, next) => {
    const { host } = ctx;
    assertExists(host, '`host` is required, you need to use `withHost` command before adding this command to the pipeline.');
    const selectionType = ctx.selectionType ?? ['block', 'text', 'image'];
    const selectedModels = getSelectedContentModels(host, selectionType);
    next({ selectedModels });
};
//# sourceMappingURL=get-selected-models.js.map